<template>
  <div
    class="video-container--content"
    :class="{
      'state-recording': recorderState === 'recording',
      'video-container--videoresume': isVideoresume
    }"
  >
    <div class="vid-int-start">
      <videointerview-no-micro v-if="noMicro" />

      <audio-test v-else-if="!isMicTestComplete" :mic-test-progress="micTestProgress" :is-videoresume="isVideoresume" />

      <videointerview-no-webcam v-else-if="noWebcam" />

      <div v-else class="vid-int-videoTest" :class="{ 'recordertest--only-audio': !isVideoAnswerEnabled }">
        <div class="vid-int-videoTest__inner vid-int-videoTest__message">
          <div class="h2">{{ $tr('interview.videointerview.testRecord') }}</div>
          <div class="vid-int-videoTest__item vid-int-videoTest__content">
            {{ $tr('videoInterview.checkVideo.info') }}
          </div>
          <!-- TODO: TASK: DEV-2141: x5 blur need to be exclude to separate file for maximizing pure component -->
          <div
            v-if="getProcessName === 'x5'"
            v-tooltip.top-start="$tr('videoInterview.checkVideo.blurToggleDisableNextStep')"
            class="vid-int-videoTest__x5-blur-toggle"
          >
            <vcheckbox :value="isX5Blurred" @click.native="toggleX5Blur" />
            <span @click="toggleX5Blur">
              {{ $tr('videoInterview.checkVideo.x5BlurToggle') }}
            </span>
          </div>
        </div>

        <div v-if="showPlayer" class="vid-int-section vid-int-videoTest__inner vid-int-videoTest__video-container">
          <video-player
            :has-video="isVideoAnswerEnabled"
            :has_playback_rates="false"
            :src="testVideo.source"
            :class="{ 'is-mobile': isMobile.any }"
            class="hiddenDuration"
          />

          <div v-if="defineRecordingFlow === 'default_ios'" class="safari-preview">
            <img src="/static/icons/vi_accept.png" alt="" />
            <div class="safari-preview__text">{{ $tr('videoInterview.checkVideo.accept') }}</div>
          </div>

          <div class="buttons-row">
            <vbutton
              class="button-grey mobile-hidden recording__button"
              label="videoInterview.checkVideo.skip"
              color="grey"
              @click="completeTest"
            />

            <vbutton
              class="vid-init-videoTest__rerecord-button button-grey mobile-hidden"
              label="videoInterview.checkVideo.retakeTest"
              color="grey"
              @click="retakeTestVideo(true)"
            />
          </div>
        </div>

        <div v-else class="vid-int-section vid-int-videoTest__inner vid-int-videoTest__img-container">
          <div class="vid-int-videoTest__video-container">
            <video-recorder
              ref="recorder"
              :disabled="false"
              :duration="10"
              :action="recorderAction"
              :upload-progress="uploadProgress"
              :height="296"
              :width="444"
              :is-videoresume="isVideoresume"
              :has-video="isVideoAnswerEnabled"
              hide-mobile-btns
              @setState="setRecorderState"
              @start="startRecording"
              @stop="stopRecording"
              @complete="completeRecording"
              @noWebcam="webcamCheckFailed"
            />

            <vue-draggable-resizable
              class="foo"
              :class="{ 'foo-video': recorderState === 'recording' }"
              :y="y"
              :min-height="88"
              :w="100"
              :h="100"
              :handles="['tm']"
              :draggable="false"
              :parent="false"
              @resizing="onResize"
            >
              <div class="foo-content-wrapper">
                <div class="foo-content">
                  {{ $tr('videoInterview.checkVideo.info') }}
                </div>
              </div>
            </vue-draggable-resizable>
          </div>

          <div class="vid-int-videoTest__container-flex vid-int-videoTest__container-btn mobile-hidden">
            <vbutton class="button-grey" label="videoInterview.checkVideo.skip" color="grey" @click="completeTest" />
          </div>
        </div>
      </div>

      <div class="fixed-block" :class="{ 'fixed-block-interview--recording': recorderState === 'recording' }">
        <template v-if="!noMicro && isMicTestComplete && !noWebcam">
          <vbutton
            v-if="recorderState !== 'recording'"
            class="button-grey"
            label="videoInterview.checkVideo.skip"
            color="grey"
            @click="completeTest"
          />

          <template v-if="testVideo && testVideo.source && !retake && recorderState !== 'recording'">
            <vbutton
              class="button-grey"
              label="videoInterview.checkVideo.retakeTest"
              color="grey"
              @click="retakeTestVideo(true)"
            />
          </template>

          <template v-else>
            <vbutton
              v-if="recorderState === 'ready'"
              label="videoInterview.checkVideo.startRecord"
              @click="startRecordEvent"
            />

            <vbutton
              v-else-if="recorderState === 'preparing'"
              :text="$tr('videoInterview.checkVideo.prepare') + '...'"
              disabled
            />

            <vbutton
              v-else-if="recorderState === 'recording'"
              class="video__button video__button_red"
              label="videoInterview.checkVideo.stopRecord"
              @click="onStopRecording"
            />

            <vbutton
              v-else-if="recorderState === 'uploading'"
              :text="$tr('videoInterview.checkVideo.upload') + '... ' + uploadProgress + '%'"
              disabled
            />
          </template>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import BrowserStore from 'store';
import VueDraggableResizable from 'vue-draggable-resizable';
import isMobile from 'ismobilejs';
import VideoPlayer from '@/components/VideoPlayer.vue';
import VideoRecorder from '@/components/VideoRecorder/index.vue';
import AudioTest from './AudioTest.vue';
import VideointerviewNoMicro from './NoMicro.vue';
import VideointerviewNoWebcam from './NoWebcam.vue';
import SafariBrowserDetector from '@/components/mixin/SafariBrowserDetector.js';
import IEBrowserDetector from '@/components/mixin/IEBrowserDetector.js';

export default {
  name: 'InterviewEquipmentCheckRecordingTest',

  components: {
    VueDraggableResizable,
    VideoPlayer,
    VideoRecorder,
    VideointerviewNoMicro,
    VideointerviewNoWebcam,
    AudioTest
  },

  mixins: [SafariBrowserDetector, IEBrowserDetector],

  props: {
    interview: {
      type: Object,
      default: () => {}
    },

    isVideoresume: Boolean
  },

  data() {
    return {
      noMicro: false,
      noWebcam: false,
      micTestProgress: 0,
      isMicTestComplete: false,
      retake: false,
      recorderAction: 'ready',
      recorderState: '',
      initMicTest: null,
      loaded: false,
      isMobile,
      // recordplay: null,

      width: 0,
      height: 0,
      x: 0,
      y: 0,
      resizableHeight: 0,
      // isAppleUpdateRecommend: false,
      // showAppleWarning: false,
      isX5Blurred: false
    };
  },

  computed: {
    ...mapState('interview/videointerview', ['testVideo', 'uploadProgress']),

    ...mapGetters('process', ['getProcessName']),

    ...mapGetters('interview/videointerview', ['isVideoAnswerEnabled']),

    showPlayer() {
      return this.testVideo && this.testVideo.source && !this.retake;
    },

    recording() {
      return this.recorderAction !== 'ready';
    },

    isShowBar() {
      return !!BrowserStore.get('is_show_bar');
    }
  },

  watch: {
    testVideo() {
      this.retake = false;
    },

    recorderState(val) {
      this.$store.commit('interview/videointerview/setRecording', val === 'recording');
    }
  },

  beforeMount() {
    // recorder = new RecordRTCPromisesHandler(stream, {})
    // window.adapter = adapter;
    const initMicTest = () => {
      let constraints = { audio: true, video: false };

      if (navigator.mediaDevices === undefined) {
        navigator.mediaDevices = {};
      }

      if (navigator.mediaDevices.getUserMedia === undefined) {
        navigator.mediaDevices.getUserMedia = function (constraints) {
          let getUserMedia = this.getUserMediaCrossPlatform;

          return new Promise(function (resolve, reject) {
            getUserMedia.call(navigator, constraints, resolve, reject);
          });
        };
      }

      navigator.getUserMedia = this.getUserMediaCrossPlatform;

      navigator.mediaDevices
        .getUserMedia(constraints)
        .then(stream => {
          this.stream = stream;
          const bufferSize = 2048;
          const step = 20;

          const audioCtx = new (window.AudioContext || window.webkitAudioContext)();
          const microphone = audioCtx.createMediaStreamSource(stream);
          const analyser = audioCtx.createAnalyser();
          const scriptProcessor = audioCtx.createScriptProcessor(bufferSize, 1, 1);

          microphone.connect(analyser);
          scriptProcessor.connect(audioCtx.destination);

          scriptProcessor.onaudioprocess = () => {
            const dataArray = new Uint8Array(bufferSize);
            analyser.getByteTimeDomainData(dataArray);

            const maxAmplitude = Math.max(...dataArray);
            const minAmplitude = Math.min(...dataArray);

            const micLoudness = maxAmplitude - minAmplitude;

            const silenceThreshold = 20;
            if (micLoudness > silenceThreshold) {
              this.micTestProgress += step;
            }

            if (this.micTestProgress >= 100) {
              scriptProcessor.onaudioprocess = null;
              this.isMicTestComplete = true;
              stream.stop();
            }
          };
        })
        .catch(err => (err ? (this.noMicro = true) : null));
    };

    if (!isMobile.any) {
      initMicTest();
    } else {
      this.isMicTestComplete = true;
      this.micTestProgress = 100;
    }
  },

  mounted() {
    // if (this.defineRecordingFlow === 'janus') {
    //   this.isAppleUpdateRecommend = true;
    // }
    // if (this.defineRecordingFlow === 'ios15') {
    //   this.showAppleWarning = true;
    // }
  },

  beforeDestroy() {
    this.$store.commit('interview/videointerview/setRecording', false);
  },

  methods: {
    toggleX5Blur() {
      this.$store.commit('services/setVideoBlur', !this.isX5Blurred);
      this.isX5Blurred = !this.isX5Blurred;
    },

    onResize(x, y, width, height) {
      this.x = x;
      this.y = y;
      this.width = width;
      this.height = height;
    },

    setRecorderState(v) {
      this.recorderState = v;
    },

    startRecordEvent() {
      this.$refs.recorder.onStartRecording();
    },

    onStopRecording() {
      this.$refs.recorder.onStopRecording();
    },

    startRecording() {
      if (this.recorderAction !== 'ready') {
        throw Error('Record not ready');
      }

      // this.$store.dispatch('interview/videointerview/startTestRecording', {
      //   interview: this.interview
      // });

      this.recorderAction = 'start';
    },

    setInitMicTest() {
      if (this.loaded) {
        return;
      }
      if (this.initMicTest) {
        this.initMicTest();
        this.loaded = true;
      }
    },

    stopRecording() {
      if (this.recorderAction !== 'start') {
        throw Error('Record not started');
      }

      this.recorderAction = 'stop';

      setTimeout(() => {
        this.recorderAction = 'ready';
      }, 800);
    },

    async completeRecording({ blob }) {
      this.recorderAction = 'ready';

      await this.$store
        .dispatch('interview/videointerview/stopTestRecording', {
          interview: this.interview,
          blob
        })
        .then(() => {
          this.recorderAction = 'ready';
        });
    },

    completeTest() {
      this.$store.commit('interview/videointerview/setRecording', false);
      this.$emit('recording-test-complete');
    },

    retakeTestVideo(state) {
      this.retake = state;
    },

    webcamCheckFailed() {
      this.noWebcam = true;
    }
  }
};
</script>

<style lang="scss" scoped>
.recording {
  &__button {
    margin-top: 1rem;
    align-self: flex-end;
  }
}

.vid-int-videoTest__container-btn {
  margin-top: 1rem;
  display: flex;
  width: 100%;
  justify-content: flex-end;

  @media screen and (max-width: 1024px) {
    display: none;
  }
}

.buttons-row {
  display: flex;
  justify-content: flex-end;

  & > * {
    margin-left: 16px !important;
  }
}

.video-container--content {
  flex: 1;
  ::v-deep {
    .button-grey.vbutton {
      background: #f4f5f7 !important;
      color: #9faab6 !important;
    }

    .vjs-fluid {
      @media screen and (max-width: 480px) {
        padding-top: 0 !important;
      }
    }
  }

  ::v-deep .video-js {
    @media only screen and (max-width: 1024px) {
      width: 100% !important;
      height: auto !important;
      padding-bottom: 66.6% !important;
    }
  }

  &.state-recording {
    align-items: flex-start;

    ::v-deep {
      .vid-int-section {
        @media screen and (max-width: 480px) {
          flex: 1;
          display: flex;
          flex-direction: column;
        }
      }
      .video-js {
        @media only screen and (max-width: 480px) {
          width: 100% !important;
          height: 100% !important;
          padding-bottom: 0 !important;
          display: flex;
          flex-direction: column;
          flex: 1;
        }
      }

      .mask-on-video {
        @media only screen and (max-width: 480px) {
          display: none;
        }
      }

      .vid-int-videoTest__video-container {
        @media only screen and (max-width: 480px) {
          display: flex;
          flex-direction: column;
          flex: 1;

          & > div {
            display: flex;
            flex-direction: column;
            flex: 1;
            & > div {
              display: flex;
              flex-direction: column;
              flex: 1;
            }
          }
          .video__container,
          .video-player {
            display: flex;
            flex-direction: column;
            flex: 1;
          }
        }
      }

      .handle-tm,
      .handle-bm {
        display: block !important;
      }

      .handle-tm {
        top: 4px;
        border: 0;
        background: #ffffff;
        border-radius: 20px;
        cursor: grab;
        width: 80px;
        height: 4px;
        left: calc(50% - 40px);
      }
    }
  }
}

.buttons-container {
  .vbutton.grey {
    background: #f4f5f7 !important;
    color: #9faab6 !important;
  }
}

.foo {
  display: none;
  padding: 1rem;
  width: 100%;
  min-width: 100%;
  min-height: 88px;
  z-index: 9999 !important;
  background: linear-gradient(360deg, #ffffff 2.5%, rgba(255, 255, 255, 0.8) 100%);
  position: absolute;
  bottom: 0;
  // bottom: 167px;
  top: auto !important;
  left: 0;
  overflow: hidden;
  box-sizing: border-box;
  border: 0;
  max-height: calc(100vh - 14.75rem);

  @media only screen and (max-width: 480px) {
    &.foo-video {
      display: flex;
      flex-direction: column;
      transform: translate(0px, 0px) !important;
    }
  }
}

.foo-content {
  overflow-y: auto;
}

.foo-content-wrapper {
  flex: 1;
  display: flex;
  position: relative;
  flex-direction: column;
  max-height: 100%;
}

.state-recording {
  @media only screen and (max-width: 480px) {
    .vid-int-videoTest__message,
    .videoInterview__questionCounter,
    .videoInterview__questions-container,
    .footer-section-wrapper,
    .pagination__button-container--desktop {
      display: none;
    }
  }
}

.videointerview {
  &__ios-warning {
    font-size: 18px;
    line-height: 1.6;

    > div {
      margin-bottom: 20px;
    }
  }
}

.video-container--content {
  width: 100%;
  max-width: 912px;
  display: flex;
  align-items: center;

  @media screen and (max-width: 1024px) {
    display: flex;
    flex-direction: column;
    flex: 1;
  }

  ::v-deep .video-js {
    @media screen and (max-width: 1024px) {
      width: 100% !important;
      height: auto !important;
      padding-bottom: 66.6% !important;
    }
  }
}
.vid-int-section {
  margin-top: 2.75rem;

  @media screen and (max-width: 1024px) {
    margin-top: 0;
  }
}

.fixed-block {
  display: none;
  position: sticky;
  bottom: 40px;
  left: 0;
  background: #fff;
  padding: 1.875rem 1rem;
  z-index: 999;
  width: 100%;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  box-sizing: border-box;

  @media only screen and (max-width: 1024px) {
    display: flex;
    padding: 2.5rem 1rem 1.25rem;
  }

  @media only screen and (max-width: 480px) {
    padding-left: 0;
    padding-right: 0;
    padding-bottom: 0.75rem;
    background: linear-gradient(360deg, #ffffff 62px, rgba(255, 255, 255, 0.5) 100%);
  }

  &.fixed-block-interview--recording {
    padding-top: 0;
    @media only screen and (max-width: 1024px) {
      padding-top: 0;
    }
    @media only screen and (max-width: 480px) {
      padding-top: 0;
      position: static;
    }
  }

  ::v-deep {
    .vbutton {
      width: 365px;
      height: 50px;
      max-height: 50px;
      min-height: 50px;

      @media only screen and (max-width: 480px) {
        width: 100%;
      }

      // &.video__button_red {
      //   background-color: #B00020 !important;

      //   &:hover,
      //   &:focus,
      //   &:active {
      //     background-color: #B00020 !important;
      //   }
      // }
    }

    > * {
      &:not(:first-child) {
        margin-top: 0.5rem;
      }
    }

    div {
      @media only screen and (max-width: 480px) {
        width: 100%;
      }
    }
  }
}

.videointerview-error-section {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-left: 16px;
  padding-right: 16px;
}

.videointerview-error-section_title {
  font-style: normal;
  font-weight: bold;
  font-size: 24px;
  line-height: 32px;
  text-align: center;
  color: #233346;
  margin-bottom: 106px;
}

.videointerview-error-section_img {
  margin-bottom: 2px;
  max-width: 124px;
  height: auto;
}

.videointerview-error-section_text {
  font-style: normal;
  font-weight: normal;
  font-size: 15px;
  line-height: 24px;
  text-align: center;
  color: #233346;
}
</style>

<style lang="scss">
.vid-int-videoTest__container-flex {
  display: flex;
}

.vid-int-start {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  flex: 1;
}

.vid-int-videoTest {
  display: flex;
  align-items: flex-start;
  justify-content: center;
  font-size: 15px;
  line-height: 24px;
  min-height: 450px;
  box-sizing: border-box;
  width: 100%;
  margin-left: auto;
  margin-right: auto;

  &__x5-blur-toggle {
    display: flex;
    align-items: center;

    > span {
      margin-left: 10px;
      cursor: pointer;
    }
  }

  @media screen and (max-width: 1024px) {
    flex-direction: column-reverse;
    padding-bottom: 245px;
    justify-content: flex-end;
    flex: 1;
  }

  @media screen and (max-width: 480px) {
    padding-bottom: 0;
  }
}

.vid-int-videoTest__message {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;

  @media screen and (max-width: 1024px) {
    margin-top: 1.5rem;
  }
}

.vid-int-videoTest__video-container {
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}

.vid-int-videoTest__inner {
  position: relative;
  margin-right: 1.5rem;
  width: 27.75rem; // 444px
  min-width: 27.75rem; // 444px
  box-sizing: border-box;
  font-size: 15px;
  line-height: 24px;

  @media screen and (max-width: 1024px) {
    margin-right: 0;
    max-width: 35rem; // 560px
    width: 100%;
    min-width: auto;
  }
}

.vid-int-videoTest__img-container,
.vid-int-videoTest__inner:last-child {
  margin-right: 0;
}

.vid-int-videoTest__button {
  color: #fff;
  width: 100%;
  text-align: center;
  cursor: pointer;
  font-size: 20px;
  line-height: 60px;
  letter-spacing: 1px;
  border: none;
  transition: all 0.7s;
}

.vid-int-videoTest__button_green {
  background-color: #49bc00;
  position: absolute;
  bottom: 0;
}

.vid-int-videoTest__button_green:hover {
  text-decoration: underline !important;
}

.vid-int-videoTest__item {
  margin-bottom: 30px;
}

.vid-int-videoTest__item:last-child {
  margin-bottom: 0;
}

.vid-int-videoTest__title {
  color: #49bc00;
}

.vid-int-videoTest__content {
  margin-bottom: 25px;
}

.vid-int-videoTest__tip {
  font-size: 15px;
  line-height: 30px;
  margin-bottom: 1%;
}

.vid-int-videoTest__tip-icon {
  color: #49bc00;
  font-size: 16px;
}

.safari-preview {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: #f2f8f1;
  z-index: 2;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  &__text {
    margin-top: 10px;
    font-size: 14px;
  }
}

.vbutton.vid-init-videoTest__rerecord-button {
  margin: 0;
  margin-top: 1rem;
  align-self: flex-end;

  @media screen and (max-width: 1024px) {
    display: none;
  }
}

// .buttons-container {
//   display: flex;
//   flex-direction: column;
//   justify-content: center;
//   align-items: center;
//   width: 100%;
// }

.mobile-hidden {
  @media screen and (max-width: 1024px) {
    display: none !important;
  }
}

.video-container--videoresume {
  .h2 {
    margin-bottom: 16px;
    // font-family: 'Euclid Circular A';
    font-style: normal;
    font-weight: bold;
    font-size: 20px;
    line-height: 28px;
    color: #555555;
    text-transform: lowercase;
  }

  .vid-int-videoTest__content {
    // font-family: 'Euclid Circular A';
    font-style: normal;
    font-weight: normal;
    font-size: 15px;
    line-height: 24px;
    color: #8d8d8d;
  }

  & {
    .vbutton {
      padding: 16px 36px;
      // font-family: 'Euclid Circular A';
      font-style: normal;
      font-weight: 500;
      font-size: 15px;
      line-height: 24px;
      max-height: 56px;
      min-height: 56px;
      height: 56px;
      text-transform: lowercase;

      &.green {
        background: linear-gradient(327.35deg, #848bd3 0%, #bc89e6 100%) !important;
        &:hover,
        &:focus,
        &:active {
          background: linear-gradient(327.35deg, #848bd3 0%, #bc89e6 100%) !important;
        }
      }

      &.video__button_red {
        background: #fafafa !important;
        color: #b36565 !important;

        &:hover,
        &:focus,
        &:active {
          background: #fafafa !important;
          color: #b36565 !important;
        }
      }
    }
  }
}

.recordertest--only-audio {
  .stream-player.is-black,
  .stream-player-video {
    background-image: url('/static/images/elements/equalizer.jpg');
    background-repeat: no-repeat;
    background-position: top center;
    background-size: cover;
  }
}
</style>
